/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

export const readFile = <T extends any>(file: File): Promise<T> =>
  new Promise<T>((res, rej) => {
    const reader = new FileReader();
    reader.onload = (e) => res(e.target?.result as T);
    reader.onerror = (e) => rej(e);
    reader.readAsText(file);
  });

export const readFileAsJson = async (file: File): Promise<unknown> => {
  const contents = await readFile<string>(file);
  const parsedContents = JSON.parse(contents);
  return parsedContents;
};
